const snapcodeUrlRegex = /^https:\/\/www.snapchat.com\/unlock\/\?type=SNAPCODE&uuid=\w+&metadata=\d+$/;
const allowedFileExtensions = ['svg', 'png'];

export const validateSnapcodeUrl = (value: string | undefined) => {
  if (value && !snapcodeUrlRegex.test(value)) {
    return 'Invalid snapcode url';
  }

  return undefined;
};

const isValidExtension = (value: string) => allowedFileExtensions.some(extension => value.endsWith(`.${extension}`));

export const validateImg = (value: File | string) => {
  const fileName = value instanceof File ? value.name : value;

  if (fileName && !isValidExtension(fileName)) {
    return `Only .${allowedFileExtensions.join(', .')} files are accepted`;
  }

  return undefined;
};
